import Picker from '../../picker/locale/zh_CN';
import DatePicker from '../../date-picker/locale/zh_CN';
import DatePickerView from '../../date-picker-view/locale/zh_CN';
import Menu from '../../menu/locale/zh_CN';
import Calendar from '../../calendar/locale/zh_CN';
import SearchBar from '../../search-bar/locale/zh_CN';
import InputItem from '../../input-item/locale/zh_CN';
import Pagination from '../../pagination/locale/zh_CN';
import PullToRefresh from '../../pull-to-refresh/locale/zh_CN';
import ActionSheet from '../../action-sheet/locale/zh_CN';

export default {
  locale: 'zh_CN',
  Picker,
  DatePicker,
  DatePickerView,
  Menu,
  Calendar,
  SearchBar,
  InputItem,
  Pagination,
  PullToRefresh,
  ActionSheet
};
